// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArmorController from "./armor_controller"
application.register("armor", ArmorController)

import AttackBrowserController from "./attack_browser_controller"
application.register("attack-browser", AttackBrowserController)

import AttributeSelectionController from "./attribute_selection_controller"
application.register("attribute-selection", AttributeSelectionController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import BulkActionsController from "./bulk_actions_controller"
application.register("bulk-actions", BulkActionsController)

import CharacterSheetController from "./character_sheet_controller"
application.register("character-sheet", CharacterSheetController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import ElementBrowserController from "./element_browser_controller"
application.register("element-browser", ElementBrowserController)

import ElementFieldsController from "./element_fields_controller"
application.register("element-fields", ElementFieldsController)

import EtiquetteSelectionController from "./etiquette_selection_controller"
application.register("etiquette-selection", EtiquetteSelectionController)

import FileImportController from "./file_import_controller"
application.register("file-import", FileImportController)

import GearSelectionController from "./gear_selection_controller"
application.register("gear-selection", GearSelectionController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeritageTraitsController from "./heritage_traits_controller"
application.register("heritage-traits", HeritageTraitsController)

import KickstarterModalController from "./kickstarter_modal_controller"
application.register("kickstarter-modal", KickstarterModalController)

import KnowledgeSelectionController from "./knowledge_selection_controller"
application.register("knowledge-selection", KnowledgeSelectionController)

import ListBrowserController from "./list_browser_controller"
application.register("list-browser", ListBrowserController)

import ListItemsController from "./list_items_controller"
application.register("list-items", ListItemsController)

import MagicSelectionController from "./magic_selection_controller"
application.register("magic-selection", MagicSelectionController)

import MissionFormController from "./mission_form_controller"
application.register("mission-form", MissionFormController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PriorityTableController from "./priority_table_controller"
application.register("priority-table", PriorityTableController)

import SkillSelectionController from "./skill_selection_controller"
application.register("skill-selection", SkillSelectionController)

import StatblockFormController from "./statblock_form_controller"
application.register("statblock-form", StatblockFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)
